module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-35-a8f5c647fe8ade804058d81282b6313a.svg";